export interface MaterialHeaderType {
    estimation_total: number | null;
    order_total: number | null;
    delivered_total: number | null;
    onSite_total: number | null;
}

// to single object maping
export const mapMaterialHeaderType = (data: any): MaterialHeaderType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialHeaderType: MaterialHeaderType = {
        estimation_total: data.estimation_total || null,
        order_total: data.order_total || null,
        delivered_total: data.delivered_total || null,
        onSite_total: data.onSite_total || null,
    }

    return materialHeaderType;
}